import React, { useContext, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connectSideNav } from 'shared/hoc/withSideNav';
import connectRoutes from 'shared/hoc/withRoutes';
import { voucherCreateCheck, voucherReportCheck, voucherViewCheck } from 'shared/api/vouchers';
import { FilterContext, prepareFilters } from 'shared/hoc/withFilters';
import { processRoutes } from 'shared/utils';
import { MODULES } from 'shared/constants';
import * as routes from 'shared/routes/voucher';
import VoucherBatchSearch from './VoucherBatchSearch';
import VoucherBatch from './VoucherBatch';
import VoucherCreator from './VoucherCreator';
import RedeemedReport from './reports/Redeemed';
import GroupedReport from './reports/Grouped';
import './style.css';

const withSideNav = connectSideNav(MODULES.voucher);

const withFilters = prepareFilters(MODULES.voucher);

const withRoutes = connectRoutes([
  {
    RouteComponent: VoucherBatch,
    path: routes.batchViewPath,
    routeToTest: voucherViewCheck,
  },
  {
    RouteComponent: VoucherBatchSearch,
    path: routes.viewPath,
    text: 'View Batches',
    routeToTest: voucherViewCheck,
    key: 'view_batches',
  },
  {
    RouteComponent: VoucherCreator,
    path: routes.createPath,
    text: 'Create Vouchers',
    routeToTest: voucherCreateCheck,
  },
  {
    path: routes.managersReportPath,
    text: 'View Reports',
    groupHead: routes.reportsPath,
    routeToTest: voucherReportCheck,
  },
  {
    RouteComponent: RedeemedReport,
    path: routes.managerReportPath,
    routeToTest: voucherReportCheck,
    model: 'manager',
    key: 'manager_report',
  },
  {
    RouteComponent: RedeemedReport,
    path: routes.complexReportPath,
    routeToTest: voucherReportCheck,
    model: 'complex',
    key: 'complex_report',
  },
  {
    RouteComponent: RedeemedReport,
    path: routes.propertyReportPath,
    routeToTest: voucherReportCheck,
    model: 'property',
    key: 'building_report',
  },
  {
    RouteComponent: GroupedReport,
    path: routes.propertiesReportPath,
    text: 'Buildings',
    group: routes.reportsPath,
    routeToTest: voucherReportCheck,
    grouping: 'property',
    key: 'building_report',
  },
  {
    RouteComponent: GroupedReport,
    path: routes.complexesReportPath,
    text: 'Complexes',
    group: routes.reportsPath,
    routeToTest: voucherReportCheck,
    grouping: 'complex',
    key: 'complex_report',
  },
  {
    RouteComponent: GroupedReport,
    path: routes.managersReportPath,
    text: 'Managers',
    group: routes.reportsPath,
    routeToTest: voucherReportCheck,
    grouping: 'manager',
    key: 'manager_report',
  },
  {
    RouteComponent: RedeemedReport,
    group: routes.reportsPath,
    path: routes.vouchersReportPath,
    text: 'Vouchers',
    routeToTest: voucherReportCheck,
    model: '',
    key: 'voucher_report',
  },
]);

/**
 * @param {Object} props
 * @param {Array<Object>} props.enabledRoutes
 */
function Voucher(props) {
  const { enabledRoutes } = props;
  const {
    savedFilters,
    getFavoriteFilters,
  } = useContext(FilterContext);

  useEffect(() => {
    if (!savedFilters) {
      getFavoriteFilters();
    }
  }, [savedFilters, getFavoriteFilters]);

  const initialVoucherNavRoutes = [];
  const initialStaticRoutes = [];

  const { staticRoutes } = processRoutes(
    enabledRoutes,
    initialStaticRoutes,
    initialVoucherNavRoutes,
    savedFilters,
  );

  return (
    <Switch>
      {staticRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          render={() => <route.RouteComponent model={route.model} grouping={route.grouping} filterKey={route.key || ''} savedFilters={route.filters || ''} path={route.path} />}
        />
      ))}
    </Switch>
  );
}

export default {
  RouteComponent: withRoutes(withFilters(withSideNav(Voucher))),
  module: 'voucher',
  name: 'Vouchers',
  path: routes.viewPath,
  rootPath: routes.rootPath,
  routeToTest: voucherViewCheck,
};
